import { NavBarDataInterface } from '@simOn/common/containers';

// Empty `navLinks` (no tabs) still renders the navbar variant with the
// hamburger button and page title instead of the bare logo bar.
export const DOCUMENTS_PAGE_DATA: NavBarDataInterface = {
  headerTitle: $localize`:@@DOCUMENTS_TITLE:Documents`,
  shortTitle: $localize`:@@DOCUMENTS_TITLE:Documents`,
  navLinks: [],
  activeLinkIndex: 0
};
